import { render } from "./LinkBanner.vue?vue&type=template&id=227c3d1e&lang=true"
import script from "./LinkBanner.vue?vue&type=script&lang=js"
export * from "./LinkBanner.vue?vue&type=script&lang=js"
script.render = render

export default script